import { ActionContext } from "vuex";
import axios from "@/plugins/axios";
import { AxiosResponse } from "axios";
import { get, set } from "@/utils/vuex";

export default {
  namespaced: true,
  state: (): any => ({
    loading: false,
  }),
  getters: {
    getLoading: get("loading"),
  },
  mutations: {
    setLoading: set("loading"),
  },
  actions: {
    async navigateToCheckoutSession(
      context: ActionContext<any, any>,
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      data: any
    ): Promise<any> {
      const payload = { ...data };

      context.commit("setLoading", true);
      const response = await axios
        .post(`/api/stripe/checkout`, payload)
        .catch((error: AxiosResponse) => {
          context.commit("snackbar/toastError", error?.data || {}, {
            root: true,
          });
          return error;
        })
        .finally(() => {
          context.commit("setLoading", false);
        });

      const { url } = response?.data || {};

      if (url) {
        window.location.href = url;
      }
    },
  },
};
